import request from "root/js/request";

export const getParsersCollectionsKeywordsById = async ({ collection_id, limit, offset, ...rest }) => {
  const response = await request({
    url: `/parsers/collections/keywords/${collection_id}/`,
    method: "get",
    params: {
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
